export default class Statistic {
  constructor() {
    this.title = new String();
    this.subtitle = new String();
  }
}
